import { Log } from '../../../../log';
export class DriverLogChannel {
    constructor(logChannel, prefix) {
        this.logChannel = logChannel;
        this.prefix = prefix;
    }
    get name() {
        return this.logChannel.name;
    }
    get debugEnabled() {
        return this.logChannel.debugEnabled;
    }
    set debugEnabled(value) {
        this.logChannel.debugEnabled = value;
    }
    debug(message) {
        this.logChannel.debug(`${this.prefix}: ${message}`);
    }
    error(message) {
        this.logChannel.error(`${this.prefix}: ${message}`);
    }
    info(message) {
        this.logChannel.info(`${this.prefix}: ${message}`);
    }
    warning(message) {
        this.logChannel.warning(`${this.prefix}: ${message}`);
    }
}
export class DriverLogFactory {
    constructor(prefix) {
        this.prefix = prefix;
    }
    channel(channelName, bufferName) {
        const baseChannel = Log.channel(channelName, bufferName);
        return new DriverLogChannel(baseChannel, this.prefix);
    }
}
